import {
  HTML_LINK_PROTOCOL_MAILTO,
  HTML_LINK_PROTOCOL_TEL,
} from '../../../constants/html'

const ENTITY_PROFILE_TAB_UPDATES_SKELETON_COUNT = 2

export const ENTITY_PROFILE_TAB_UPDATES_INITIAL_VISIBLE_COUNT = 5

export const ENTITY_PROFILE_TAB_UPDATES_GROUP_START_INDEX = 0

export const ENTITY_PROFILE_TAB_UPDATES_TEXT_MAX_LINES = 2

export const ENTITY_PROFILE_TAB_UPDATES_OWNER_TYPE = {
  deleted: 'deleted',
  regular: 'regular',
  system: 'system',
  worker: 'worker',
}

export const QA_NAME_ENTITY_PROFILE_TAB_UPDATES_SHOW_ALL =
  'entityProfileTabUpdatesShowAll'

export const QA_NAME_ENTITY_PROFILE_TAB_UPDATES_OWNER_NAME =
  'entityProfileTabUpdatesOwnerName'

export const QA_NAME_ENTITY_PROFILE_TAB_UPDATES_CARD =
  'entityProfileTabUpdatesCard'

export const QA_NAME_ENTITY_PROFILE_TAB_UPDATES_ENTITY_LINK =
  'entityProfileTabUpdatesEntityLink'

export const ENTITY_PROFILE_TAB_UPDATES_LINK_PROTOCOLS = [
  HTML_LINK_PROTOCOL_MAILTO,
  HTML_LINK_PROTOCOL_TEL,
]

export const ENTITY_PROFILE_TAB_UPDATES_CONTENT_TRANS_PROPS = {
  shouldUnescape: true,
  tOptions: { interpolation: { escapeValue: true } },
}

export const ENTITY_PROFILE_TAB_UPDATES_SKELETON_INDICES = Array.from(
  { length: ENTITY_PROFILE_TAB_UPDATES_SKELETON_COUNT },
  (_, index) => index
)
